import { Component, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DialogService,
  DynamicDialogComponent,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import {
  ProviderBrandsSearchRequestInterface,
  ProviderBrandsSearchResponseData,
} from '../../../core/interfaces/blog/provider-brands-search';
import { Table, TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ProviderBrandsService } from '../../../core/services/brands/provider-brands.service';
import { GlobalMessageService } from '../../../core/services/global-services/global-message-service/global-message.service';
import { Subject, takeUntil } from 'rxjs';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddon } from 'primeng/inputgroupaddon';

@Component({
  selector: 'magenty-brand-selection',
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    InputGroup,
    InputGroupAddon,
  ],
  templateUrl: './brand-selection.component.html',
  styleUrl: './brand-selection.component.scss',
})
export class BrandSelectionComponent implements OnDestroy {
  brandService = inject(ProviderBrandsService);
  globalMessageService = inject(GlobalMessageService);
  totalRecords = 0;
  request: ProviderBrandsSearchRequestInterface = {
    ProviderId: '',
    MarketplaceIdentity: 0,
    Page: 0,
    PageSize: 10,
    ExtraFilter: { RefreshCategories: '' },
    SearchKey: '',
  };
  dataSource: ProviderBrandsSearchResponseData[] | undefined;
  newRequest = false;
  instance: DynamicDialogComponent | undefined;
  private destroy$ = new Subject<void>();

  constructor(
    public ref: DynamicDialogRef,
    private dialogService: DialogService
  ) {
    this.instance = this.dialogService.getInstance(this.ref);
    if (this.instance && this.instance.data) {
      if (this.instance.data.providerId) {
        this.request.ProviderId = this.instance.data.providerId;
        this.request.MarketplaceIdentity =
          this.instance.data.marketplaceIdentity;
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getBrands = () => {
    if (!this.newRequest) {
      this.request.ExtraFilter = undefined;
    } else {
      this.request.ExtraFilter = { RefreshCategories: '' };
    }
    this.brandService
      .providerBrands(this.request)
      .pipe(takeUntil(this.destroy$))
      .subscribe((f) => {
        this.totalRecords = f.Page.TotalItemCount || 0;
        this.dataSource = f.Data;

        if (f.ShowingMessage === null) {
          f.ShowingMessage =
            f.Data?.length > 0
              ? 'Marka indirme işlemi başlatıldı.'
              : 'Marka indirme işlemi başarısız';
        }

        if (this.newRequest) {
          this.globalMessageService.showStatusMessages({
            status: f && f.Data?.length > 0,
            summary: 'Marka Yenileme',
            infoDetail: f.ShowingMessage,
            errorDetail: f.ShowingMessage,
          });
          this.newRequest = false;
        }
      });
  };

  loadBrands(event: TableLazyLoadEvent) {
    if (
      event.first !== undefined &&
      event.rows !== undefined &&
      event.rows !== null
    ) {
      this.request.Page =
        event.first === 0 ? 0 : (event.first ?? event.rows) / event.rows;
      this.request.PageSize = event.rows;
    }
    if (event.globalFilter && event.globalFilter?.length > 0) {
      if (event.globalFilter !== this.request.SearchKey) {
        this.request.Page = 0;
      }
      if (typeof event.globalFilter === 'string') {
        this.request.SearchKey = event.globalFilter;
      }
    } else {
      this.request.SearchKey = '';
    }
    this.getBrands();
  }

  clear(table: Table) {
    this.request.SearchKey = '';
    this.request.Page = 0;
    this.request.PageSize = 10;
    table.clear();
  }
}
